<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Evacuation Routes, Reunification Sites, and Staging Areas
                </h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip"
                    class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>Select a document on the left. Fire, Bomb, and Severe Weather are lists you can add to; Crisis Event Staging Areas is a single form.</p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow gap-8 items-start overflow-y-auto">
        <!-- LEFT: document toggle -->
        <div class="w-1/3 max-h-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col gap-4">
            <div class="flex flex-row w-full items-center justify-between">
                <h2 class="oswald-font text-3xl font-medium">DOCUMENT</h2>
            </div>
            <div class="h-full w-full flex flex-wrap text-gray-900 overflow-y-auto">
                <div class="h-full w-full mr-2 flex flex-col gap-2">
                    <div class="w-full flex flex-row items-stretch gap-2" *ngFor="let doc of docs">
                        <button
                            class="min-h-10 flex-1 px-2.5 py-1.5 flex flex-row gap-2 items-center justify-between rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 hover:text-white hover:border-nside-orange-100 group"
                            [ngClass]="{
                                'bg-gray-50 border border-nside-gray-300': selectedDoc !== doc,
                                'bg-gradient-to-b from-nside-orange-100 to-nside-orange-200 text-white border-nside-orange-100': selectedDoc === doc
                                }" (click)="$event.preventDefault(); selectDoc(doc);">
                            <span class="text-start">{{ doc }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- RIGHT: content by selected doc -->
        <div class="w-2/3 h-full min-h-0 flex flex-col gap-4">

            <!-- Fire / Bomb : route + site CRUD table -->
            <div *ngIf="isRouteDoc" class="max-h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4">
                <div class="w-full flex items-center justify-between">
                    <h3 class="oswald-font text-xl font-medium">{{ selectedDoc }}</h3>
                    <button *ngIf="canSave()" (click)="$event.preventDefault(); openAddRoute();"
                        class="px-2 py-1.5 flex flex-row gap-2 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font">
                        <lucide-icon [img]="icons.Plus"></lucide-icon>
                        Add New
                    </button>
                </div>

                <ng-container *ngIf="routeList.length > 0; else emptyRoutes">
                    <div class="h-full w-full overflow-y-auto">
                        <table class="w-full text-left table-fixed">
                            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                <tr>
                                    <th scope="col" class="h-12 px-4 py-3 w-14"><div class="whitespace-nowrap">No.</div></th>
                                    <th scope="col" class="px-4 py-3 w-2/5">
                                        <div (click)="$event.preventDefault(); sortRoutes('route')" class="flex items-center gap-1 cursor-pointer whitespace-nowrap">
                                            Route <lucide-icon [name]="icons.ArrowUpDown" [size]=20 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-4 py-3 w-2/5">
                                        <div (click)="$event.preventDefault(); sortRoutes('site')" class="flex items-center gap-1 cursor-pointer whitespace-nowrap">
                                            Site <lucide-icon [name]="icons.ArrowUpDown" [size]=20 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-32 px-4 py-3" *ngIf="canSave()"><div class="whitespace-nowrap">Actions</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of routeList | paginate: { id: 'routes', itemsPerPage: itemsPerPage, currentPage: routePage }; let i=index;" class="bg-white border-b">
                                    <th scope="row" class="px-4 py-4 align-top">{{ i + 1 + (routePage - 1) * itemsPerPage }}</th>
                                    <td class="px-4 py-4 font-medium align-top"><p class="w-full break-all [overflow-wrap:anywhere] whitespace-pre-line">{{ item.route }}</p></td>
                                    <td class="px-4 py-4 font-medium align-top"><p class="w-full break-all [overflow-wrap:anywhere] whitespace-pre-line">{{ item.site }}</p></td>
                                    <td class="px-4 py-4 font-medium align-top" *ngIf="canSave()">
                                        <div class="flex gap-2">
                                            <button (click)="$event.preventDefault(); openEditRoute(item);"
                                                class="max-w-20 py-2 px-3 font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">Edit</button>
                                            <button (click)="$event.preventDefault(); openDelete(item, 'route');"
                                                class="max-w-20 py-2 px-3 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-template #emptyRoutes>
                    <p class="w-full text-nside-gray-100 italic text-start">Empty list</p>
                </ng-template>
                <div class="w-full flex justify-between items-center">
                    <p>{{ routeList.length }} in total</p>
                    <pagination-controls id="routes" *ngIf="routeList.length > itemsPerPage"
                        (pageChange)="routePage = $event" previousLabel="Prev" nextLabel="Next" class="mt-2"></pagination-controls>
                </div>
            </div>

            <!-- Severe Weather : location CRUD table -->
            <div *ngIf="isSevereDoc" class="max-h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4">
                <div class="w-full flex items-center justify-between">
                    <h3 class="oswald-font text-xl font-medium">Severe Weather Sheltering Locations</h3>
                    <button *ngIf="canSave()" (click)="$event.preventDefault(); openAddSevere();"
                        class="px-2 py-1.5 flex flex-row gap-2 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font">
                        <lucide-icon [img]="icons.Plus"></lucide-icon>
                        Add New
                    </button>
                </div>

                <ng-container *ngIf="severeList.length > 0; else emptySevere">
                    <div class="h-full w-full overflow-y-auto">
                        <table class="w-full text-left table-fixed">
                            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                <tr>
                                    <th scope="col" class="h-12 px-4 py-3 w-14"><div class="whitespace-nowrap">No.</div></th>
                                    <th scope="col" class="px-4 py-3"><div class="whitespace-nowrap">Sheltering Location</div></th>
                                    <th scope="col" class="px-4 py-3 w-40" *ngIf="canSave()"><div class="whitespace-nowrap">Actions</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of severeList | paginate: { id: 'severe', itemsPerPage: itemsPerPage, currentPage: severePage }; let i=index;" class="bg-white border-b">
                                    <th scope="row" class="px-4 py-4 align-top">{{ i + 1 + (severePage - 1) * itemsPerPage }}</th>
                                    <td class="px-4 py-4 font-medium align-top"><p class="w-full break-all [overflow-wrap:anywhere] whitespace-pre-line">{{ item.location }}</p></td>
                                    <td class="px-4 py-4 font-medium align-top" *ngIf="canSave()">
                                        <div class="flex gap-2">
                                            <button (click)="$event.preventDefault(); openEditSevere(item);"
                                                class="max-w-20 py-2 px-3 font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">Edit</button>
                                            <button (click)="$event.preventDefault(); openDelete(item, 'severe');"
                                                class="max-w-20 py-2 px-3 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-template #emptySevere>
                    <p class="w-full text-nside-gray-100 italic text-start">Empty list</p>
                </ng-template>
                <div class="w-full flex justify-between items-center">
                    <p>{{ severeList.length }} in total</p>
                    <pagination-controls id="severe" *ngIf="severeList.length > itemsPerPage"
                        (pageChange)="severePage = $event" previousLabel="Prev" nextLabel="Next" class="mt-2"></pagination-controls>
                </div>
            </div>

            <!-- Crisis Event Staging Areas : single structured form -->
            <form *ngIf="isCrisisDoc" #crisisForm="ngForm" (ngSubmit)="saveCrisis()"
                class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4 overflow-hidden">
                <h3 class="oswald-font text-3xl text-nside-orange-400 shrink-0">Crisis Event "Staging" Areas</h3>

                <div class="flex-1 min-h-0 w-full overflow-y-auto flex flex-col gap-6 pr-1">
                <div *ngFor="let section of crisisSections" class="w-full flex flex-col gap-3">
                    <h4 class="oswald-font text-xl font-medium border-b border-gray-200 pb-1">{{ section.title }}</h4>
                    <div class="flex flex-col px-1 gap-4">
                        <div *ngFor="let field of section.fields" class="flex flex-col gap-1">
                            <span class="font-medium text-gray-900">{{ field.label }}</span>
                            <p *ngIf="!canSave()" class="whitespace-pre-line break-words"
                                [ngClass]="crisis[field.key] ? 'text-gray-900' : 'text-gray-400 italic'">{{ crisis[field.key] || 'Empty' }}</p>
                            <textarea *ngIf="canSave()" [name]="field.key" [(ngModel)]="crisis[field.key]" rows="2"
                                class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2"
                                placeholder="Enter here"></textarea>
                        </div>
                    </div>
                </div>
                </div>

                <div class="w-full shrink-0 flex flex-row gap-2 items-center justify-between">
                    <div *ngIf="crisis.last_updated_at" class="flex flex-col items-start">
                        <p class="oswald-font font-normal">Last Updated At: <span class="raleway-font">{{ crisis.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span></p>
                        <p class="oswald-font font-normal">By: <span class="raleway-font">{{ crisis.last_updated_user_name || 'None' }}</span></p>
                    </div>
                    <button *ngIf="canSave()" type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white ml-auto border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200">
                        Save
                    </button>
                </div>
            </form>

            <!-- Relocation Sites doc : two gray tabs (Relocation Sites / Reunification Team) -->
            <div *ngIf="isRelocationDoc" class="max-h-full w-full min-h-0 flex flex-col">
                <div class="relative z-10 w-full flex flex-wrap items-end justify-start gap-1 shrink-0">
                    <button *ngFor="let tab of relocationTabs"
                        class="min-w-32 px-3 py-2 rounded-t-lg oswald-font shadow-custom-2 text-lg text-center cursor-pointer"
                        [ngClass]="{
                            'bg-white text-nside-orange-400': selectedRelocationTab === tab,
                            'bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 text-white': selectedRelocationTab !== tab
                        }"
                        (click)="$event.preventDefault(); selectRelocationTab(tab);">
                        {{ tab }}
                    </button>
                </div>

                <!-- Tab: Relocation Sites (matrix grid form) -->
                <form *ngIf="selectedRelocationTab === 'Relocation Sites'" #relocationForm="ngForm" (ngSubmit)="saveRelocation()"
                    class="flex-1 min-h-0 w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4 overflow-hidden">
                <h3 class="oswald-font text-3xl text-nside-orange-400 shrink-0">Relocation Sites</h3>

                <div class="flex-1 min-h-0 w-full overflow-y-auto">
                    <table class="w-full text-left table-fixed">
                        <thead class="oswald-font text-gray-700 bg-main-background">
                            <tr>
                                <th class="px-4 py-3 w-1/4"><div class="whitespace-nowrap">Contact Info</div></th>
                                <th class="px-4 py-3">Primary Relocation Site</th>
                                <th class="px-4 py-3">Secondary Relocation Site</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of relocationGrid" class="border-b align-top">
                                <th scope="row" class="px-4 py-4 font-medium align-top"><span class="break-words [overflow-wrap:anywhere]">{{ row.label }}</span></th>
                                <td class="px-4 py-3 align-top">
                                    <p *ngIf="!canSave()" class="whitespace-pre-line break-words"
                                        [ngClass]="relocation[row.primary] ? 'text-gray-900' : 'text-gray-400 italic'">{{ relocation[row.primary] || 'Empty' }}</p>
                                    <textarea *ngIf="canSave()" [name]="row.primary" [(ngModel)]="relocation[row.primary]" rows="2"
                                        class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Enter here"></textarea>
                                </td>
                                <td class="px-4 py-3 align-top">
                                    <p *ngIf="!canSave()" class="whitespace-pre-line break-words"
                                        [ngClass]="relocation[row.secondary] ? 'text-gray-900' : 'text-gray-400 italic'">{{ relocation[row.secondary] || 'Empty' }}</p>
                                    <textarea *ngIf="canSave()" [name]="row.secondary" [(ngModel)]="relocation[row.secondary]" rows="2"
                                        class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Enter here"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-full shrink-0 flex flex-row gap-2 items-center justify-between">
                    <div *ngIf="relocation.last_updated_at" class="flex flex-col items-start">
                        <p class="oswald-font font-normal">Last Updated At: <span class="raleway-font">{{ relocation.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span></p>
                        <p class="oswald-font font-normal">By: <span class="raleway-font">{{ relocation.last_updated_user_name || 'None' }}</span></p>
                    </div>
                    <button *ngIf="canSave()" type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white ml-auto border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200">
                        Save
                    </button>
                </div>
            </form>

                <!-- Tab: Reunification Team (embedded core planning team) -->
                <div *ngIf="selectedRelocationTab === 'Reunification Team'" class="flex-1 min-h-0 w-full">
                    <core-planning-team
                        [embedded]="true"
                        [teamTypeOverride]="reunificationTeamType"
                        [titleOverride]="'Reunification Team'"
                    ></core-planning-team>
                </div>
            </div>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<evacuation-route-form
    *ngIf="showRouteForm"
    [itemToEdit]="routeFormItem"
    [routeType]="routeType"
    [typeLabel]="selectedDoc"
    (onClose)="closeRouteForm()"
    (onSave)="handleRouteSaved($event)"
></evacuation-route-form>

<severe-weather-form
    *ngIf="showSevereForm"
    [itemToEdit]="severeFormItem"
    (onClose)="closeSevereForm()"
    (onSave)="handleSevereSaved($event)"
></severe-weather-form>

<delete-confirmation
    *ngIf="showDeleteConfirmation"
    [text]="'this item'"
    [itemToDelete]="deleteItem"
    (onClose)="closeDelete()"
    (onDelete)="handleDelete($event)"
></delete-confirmation>

<popup-message [type]="messageModal" [message]="popupMessage" (close)="resetMessageModal()"></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
